// src/notifications/globalHandlers.js
//
// Captures the errors React's ErrorBoundary can't see:
//   - promise rejections with no .catch()        (unhandledrejection)
//   - runtime errors thrown outside React's tree (window 'error': timers,
//     non-React event handlers, etc.)
// Render/lifecycle errors stay with ErrorBoundary. Installed once from index.js.

import { reportError } from './errorBus';

let installed = false;

export function installGlobalErrorHandlers() {
    if (installed || typeof window === 'undefined') return;
    installed = true;

    window.addEventListener('unhandledrejection', (event) => {
        // Axios errors already surfaced by the interceptor are tagged and ignored
        // inside reportError, so this only adds genuinely-unhandled rejections.
        reportError(event?.reason, { source: 'promise', title: 'Unhandled error' });
    });

    window.addEventListener('error', (event) => {
        // Resource-load failures (img/script) fire 'error' with no `.error`;
        // ignore those — only report real exceptions. We don't preventDefault,
        // so the CRA dev error overlay still shows in development.
        if (event && event.error) {
            reportError(event.error, { source: 'window', title: 'Unexpected error' });
        }
    });
}
